var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSubmitDone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M20.78 6.97a.75.75 0 0 1 0 1.06L10.5 18.31l-6.53-6.53a.75.75 0 1 1 1.06-1.06l5.47 5.47 9.22-9.22a.75.75 0 0 1 1.06 0",
  clipRule: "evenodd"
})));
export default SvgIconSubmitDone;